<div class="min-w-[50rem]">

    <div class="flex justify-between items-center mb-3 pb-2">
        <h2 class="text-lg font-semibold">Dados da inscrição da equipe</h2>
    </div>

    <sigecom-input-search-new padding="p-[12px]" type="text" placeholder="Buscar..." (debouncedInput)="incTxResumoChange($event)" />

    <div class="mt-6 mb-6 flex flex-col gap-2">
        <div class="flex overflow-auto max-h-[20rem] flex-col gap-3">
            <sigecom-list-item *ngFor="let participante of iCompleteEnrollmentDto()?.incObjParticipantes"
                bgColor="bg-[#E5E7EB] rounded-[10px]">
                <div class="flex justify-between">
                    <span class="font-semibold">{{ participante.usuTxNome }}</span>
                    <sigecom-menu-bar-item (clickAction)="openDetails(participante.atlNrId!)" icon="eye" color="sigecom-info"
                        title="Ver mais informações do atleta" />
                </div>
            </sigecom-list-item>
        </div>
    </div>

    <!-- Paginação -->
    <sigecom-pagination-list [totalPages]="10" [maxDisplayedPages]="10" (pageChange)="onPageChange($event)" />
</div>